<template>
    <div>
      <FormulaBanner :title="title" :formulaCode="formulaCode"/>
      <div class="index">
        <!-- 表单 -->
        <div>
          <div class="top_nav"><span></span>{{ title }}
          </div>
          <div class="formBody">
            <!-- 表单 -->
            <van-form @submit="onSubmit">
              <MyPatient :memberId="memberId" :selectValue="selectValue" @change="userChange"/>
              <!-- <div style="padding: 0 10px;border-bottom: 1px solid #f0f0f0;height: 40px;display: flex; align-items: center;font-weight: 600;">全身</div> 
              <van-field
                  v-model="xinshuchu"
                  :rules="[{ required: true, message: '请输入' }]"
              >
                <template #input>
                  <div class="titles">
                    <span class="titlesName">心输出量CO<i>*</i></span>
                    <span style="display: flex;">
                      <span class="information">
                        <van-cell-group class="vanCell" style="width:166px">
                          <van-field class="custom-field" input-align="right"  v-model="xinshuchu" placeholder="有效范围：0.5-30 L/min" />
                        </van-cell-group>
                      </span>
                      <div class="unit"><span>L/min</span></div>
                    </span>
                  </div>
                </template>
              </van-field>
              <van-field
                  v-model="MAP"
                  :rules="[{ required: true, message: '请输入' }]"
              >
                <template #input>
                  <div class="titles">
                    <span class="titlesName">平均动脉压MAP<i>*</i></span>
                    <span style="display: flex;">
                     <span class="information">
                       <van-cell-group class="vanCell" style="width:160px">
                         <van-field class="custom-field" input-align="right"  v-model="MAP" placeholder="有效范围：0-100mmHg" />
                       </van-cell-group>
                     </span>
                     <div class="unit" ><span>mmHg</span></div>
                   </span>
                  </div>
                </template>
              </van-field>
              <van-field
                  v-model="CVP"
                  :rules="[{ required: true, message: '请输入' }]"
              >
                <template #input>
                  <div class="titles">
                    <span class="titlesName">中心静脉压CVP<i>*</i></span>
                    <span style="display: flex;">
                     <span class="information">
                       <van-cell-group class="vanCell" style="width:144px">
                         <van-field class="custom-field" input-align="right"  v-model="CVP" placeholder="有效范围：0-100mmHg" />
                       </van-cell-group>
                     </span>
                     <div class="unit" ><span>mmHg</span></div>
                   </span>
                  </div>
                </template>
              </van-field>
              <van-field
                  v-model="TBMJ"
                  :rules="[{ required: true, message: '请输入' }]"
              >
                <template #input>
                  <div class="titles">
                    <span class="titlesName">体表面积<i>*</i></span>
                    <span style="display: flex;">
                     <span class="information">
                       <van-cell-group class="vanCell" style="width:144px">
                         <van-field class="custom-field" input-align="right"  v-model="TBMJ" placeholder="有效范围：0.1-4m²" />
                       </van-cell-group>
                     </span>
                     <div class="unit" ><span>m²</span></div>
                   </span>
                  </div>
                </template>
              </van-field> -->

              <!-- <div style="padding: 0 10px;border-bottom: 1px solid #f0f0f0;height: 40px;display: flex; align-items: center;font-weight: 600;">呼吸</div> -->
              <van-field
                  v-model="huxiCO"
                  :rules="[{ required: true, message: '请输入' }]"
              >
                <template #input>
                  <div class="titles">
                    <span class="titlesName">心输出量CO<i>*</i></span>
                    <span style="display: flex;">
                      <span class="information">
                        <van-cell-group class="vanCell" style="width:166px">
                          <van-field class="custom-field" input-align="right"  v-model="huxiCO" placeholder="有效范围：0.5-30 L/min" />
                        </van-cell-group>
                      </span>
                      <div class="unit"><span>L/min</span></div>
                    </span>
                  </div>
                </template>
              </van-field>
              <van-field
                  v-model="MPAP"
                  :rules="[{ required: true, message: '请输入' }]"
              >
                <template #input>
                  <div class="titles">
                    <span class="titlesName">平均肺动脉压MPAP<i>*</i></span>
                    <span style="display: flex;">
                      <span class="information">
                        <van-cell-group class="vanCell" style="width:166px">
                          <van-field class="custom-field" input-align="right"  v-model="MPAP" placeholder="有效范围：0-100mmHg" />
                        </van-cell-group>
                      </span>
                      <div class="unit"><span>mmHg</span></div>
                    </span>
                  </div>
                </template>
              </van-field>
              <van-field
                  v-model="PCWP"
                  :rules="[{ required: true, message: '请输入' }]"
              >
                <template #input>
                  <div class="titles">
                    <span class="titlesName">肺毛细血管楔压PCWP<i>*</i></span>
                    <span style="display: flex;">
                      <span class="information">
                        <van-cell-group class="vanCell" style="width:166px">
                          <van-field class="custom-field" input-align="right"  v-model="PCWP" placeholder="有效范围：0-100mmHg" />
                        </van-cell-group>
                      </span>
                      <div class="unit"><span>mmHg</span></div>
                    </span>
                  </div>
                </template>
              </van-field>
              <van-field
                  v-model="BSA"
                  :rules="[{ required: true, message: '请输入' }]"
              >
                <template #input>
                  <div class="titles">
                    <span class="titlesName">体表面积BSA<i>*</i></span>
                    <span style="display: flex;">
                      <span class="information">
                        <van-cell-group class="vanCell" style="width:166px">
                          <van-field class="custom-field" input-align="right"  v-model="BSA" placeholder="有效范围：0.1-4m²" />
                        </van-cell-group>
                      </span>
                      <div class="unit"><span>m²</span></div>
                    </span>
                  </div>
                </template>
              </van-field>
              <div v-if="compute === true" style="margin: 16px;display: flex;justify-content: center;">
                <van-button class="formula-template-button" block type="info"  native-type="submit" style="width:90px">提交</van-button>
              </div>
            </van-form>
          </div>
        </div>
        <!-- 计算结果 -->
        <multipleResult v-if="show" :countText="countText" :countTextList="countResultARR"></multipleResult>
        <!-- 后台设置的值 -->
        <div v-if="tableData.explain && tableData.explain.length > 0">
          <div v-for="(item,index) in tableData.explain" :key="index" class="StandardDescription">
            <div class="top_nav"><span></span>{{item.title}}</div>
            <div class="StandardDeatil">
              <span v-html="item.value">
              </span>
            </div>
          </div>
        </div>
        <!-- 参考文献 -->
        <!-- <div style="margin-bottom:50px;" v-if="tableData.references && tableData.references.length > 0">
          <div class="StandardDescription">
            <div class="top_nav"><span></span>参考文献</div>
            <div class="StandardDeatil2">
              <span v-for="(item,index) in tableData.references" :key="item.title" >
              <div v-if="index !== 0" style="margin: 0 -10px 10px -10px;border-top: 1px solid #E7E7E7"></div>
                <div v-html="index+ 1 + '、' + item.title" class="references" @click="openLink(item.link)">
                </div>
              </span>
            </div>
          </div>
        </div> -->
        <FormulaReferences :references-data="references"></FormulaReferences>
      </div>
    </div>
  </template>
  
  <script>
  import MyPatient from '@/components/MyPatient.vue'
  import FormulaBanner from '@/components/FormulaBanner.vue'
  import {Toast} from "vant";
  import {getAdmins} from "@/utils/adminDate";
  import {setById} from "@/service/base";
  import {getFormula, getFormulaHuiXian, postFormula} from "@/service/BodyMassIndex_api";
  import multipleResult from "@/components/multipleResult";
  import FormulaReferences from '../../../components/template1/FormulaReferences.vue';
  export default {
    name: "medicalSearch",
    data(){
      return{
        references:[],
        compute:true,
        show:false,
        countTextList:[],
        formulaCode: '',
        houxishi: '',
        chaolv:'',
        MAP:'',
        CVP:'',
        TBMJ:'',
        yingjizhishu: '',
        title: '血管阻力（呼吸）',
        memberId: '1111',
        selectValue: '',
        username:"",
        value:"",
        showPopover: false,
        showPicker: false,
        xinshuchu: '',
        huxiCO: '',
        MPAP: '',
        PCWP: '',
        BSA: '',
        xingbie: null,
        tableData: {},
        countText: '',
        patientId: null,
        result: null,
        yingjizhishuzhi: '',
        qianxishi: '',
        xueqingnanongdu: '',
        zongzhiliao:'',
        CRRT:'',
        nianling:'',
        xinzhishu: '',
        QSXGZL: '',
        PVRvalue: '',
        PVRIvalue: '',
      }
    },
    components: {
      FormulaBanner,
      MyPatient,
      multipleResult,
      FormulaReferences
    },
    async created() {
      await this.test()
      await this.getTableData()
    },
    watch:{
      "xinshuchu":{
        immediate:true,
        handler:function(){
          this.show = false;
        }
      },
      "huxiCO":{
        immediate:true,
        handler:function(){
          this.show = false;
        }
      },
      "MPAP":{
        immediate:true,
        handler:function(){
          this.show = false;
        }
      },
      "PCWP":{
        immediate:true,
        handler:function(){
          this.show = false;
        }
      },
      "BSA":{
        immediate:true,
        handler:function(){
          this.show = false;
        }
      },
      "MAP":{
        immediate:true,
        handler:function(){
          this.show = false;
        }
      },
      "CVP":{
        immediate:true,
        handler:function(){
          this.show = false;
        }
      },
      "TBMJ":{
        immediate:true,
        handler:function(){
          this.show = false;
        }
      },
    },
    methods:{
      coumputTetxt () {
        // 呼吸：
        // PVR（肺血管阻力） = (mPAP - PCWP) ＊79.9/ CO
        // PVRI（肺血管阻力指数）＝ (mPAP - PCWP)＊79.9 / CI
        this.xinzhishu = (this.huxiCO/this.BSA).toFixed(2)
        this.PVRvalue = ((this.MPAP-this.PCWP)*79.9/this.huxiCO).toFixed(2)
        this.PVRIvalue = ((this.MPAP-this.PCWP)*79.9/this.xinzhishu).toFixed(2)


        this.countResultARR = 
          [
            {name:'Cl（心指数）',result:this.xinzhishu,unit:'L/min/m²'},
            // {name:'SVR（全身血管阻力）',result:this.QSXGZL,unit:'dynes*s/cm⁵'},
            // {name:'SVRI（全身血管阻力指数）',result:this.SVRI,unit:'dynes*s/cm⁵/m²'},
            {name:'PVR（肺血管阻力）',result:this.PVRvalue,unit:'dynes*s/cm⁵'},
            {name:'PVRI（肺血管阻力指数）',result:this.PVRIvalue,unit:'dynes*s/cm⁵/m²'},
          ]
        
        this.countText = `
          Cl（心指数） ${this.xinzhishu} L/min/m²；
          PVR（肺血管阻力） ${this.PVRvalue} dynes*s/cm⁵；
          PVRI（肺血管阻力指数） ${this.PVRIvalue} dynes*s/cm⁵/m²；
        `
      },
      async test(){
        //像接口头部传用户信息
        let arrays = await getAdmins(this.$route.query.memberId,this.$route.query.channel)
        this.channel = arrays.os
        this.version = arrays.version
        this.ip = arrays.ip
        await setById(arrays)
      },
      async getTableData () {
        const data = {
          channel: this.$router.currentRoute.query.channel,
          code: 'ZNHHFOAP',
        }
        const res = await getFormula(data.channel, data.code)
        if (res.code === 0) {
          this.tableData = res.data
          this.formulaCode = res.data.code
          this.references = res.data.references
        }
        if (this.$router.currentRoute.query.location === 'YXGS_RECORD_LIST' && this.$router.currentRoute.query.logId) {
          const data = {
            id: this.$router.currentRoute.query.logId
          }
          const res = await getFormulaHuiXian(data)
          if (res.code === 0) {
            // this.xinshuchu = res.data.content.xinshuchu.value
            // this.MAP = res.data.content.MAP.value
            // this.CVP = res.data.content.CVP.value
            // this.TBMJ = res.data.content.TBMJ.value

            this.huxiCO = res.data.content.huxiCO.value
            this.MPAP = res.data.content.MPAP.value
            this.PCWP = res.data.content.PCWP.value
            this.BSA = res.data.content.BSA.value
            this.countResultARR = res.data.content.countResultARR
            if (res.data.patientId) this.selectValue = {id: res.data.patientId, name: res.data.patientName}
            this.coumputTetxt()
          }
          this.$nextTick(() => {
            this.show=true
          })
          // this.compute = false
        }
      },
      calculateAge(birthDateString) {
        const today = new Date();
        const birthDate = new Date(birthDateString);
        let age = today.getFullYear() - birthDate.getFullYear();
        // 如果今天的日期还没到生日月份和日期，则年龄减一
        if (today.getMonth() < birthDate.getMonth() ||
            (today.getMonth() === birthDate.getMonth() && today.getDate() < birthDate.getDate())) {
          age--;
        }
        return age;
      },
      // 开参考文献链接
      openLink(u){
        if (!u) {
          return
        }
        //获取系统版本
        let userAI = navigator.userAgent;
        const isAndroid = userAI.indexOf('Android') > -1 || userAI.indexOf('Linux') > -1; //Android终端
        const isIOS = !!userAI.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
        if (isAndroid) {
          // alert('安卓操作系统')
          // 这个是安卓操作系统
          window.open(u)
        }
        if (isIOS) {
          // 这个是ios操作系统
          // alert('ios操作系统')
          window.location.href = u
        }
      },
      yingjiClick () {
        this.showPicker = true
      },
      onConfirm(value) {
        this.yingjizhishu = value
        this.showPicker = false
      },
      onCancel() {
        this.showPicker = false
      },
      async onSubmit(){
        this.coumputTetxt()
        const data = {
          id: this.$router.currentRoute.query.location === 'YXGS_RECORD_LIST' ? this.$router.currentRoute.query.logId : null,
          patientId: this.patientId,
        //   columnCode: this.tableData.columnCode,
          columnCode: 'jsgs',
          formulaCode: this.tableData.code,
          channel: this.$router.currentRoute.query.channel,
          location: this.$router.currentRoute.query.location,
          content: {
            // xinshuchu: {value: this.xinshuchu, unit: 'L/min'},
            // MAP: {value: this.MAP, unit: 'mmHg'},
            // CVP: {value: this.CVP, unit: 'mmHg'},
            // TBMJ: {value: this.TBMJ, unit: 'm²'},

            huxiCO: {value: this.huxiCO, unit: 'L/min'},
            MPAP: {value: this.MPAP, unit: 'mmHg'},
            PCWP: {value: this.PCWP, unit: 'mmHg'},
            BSA: {value: this.BSA, unit: 'm²'},
          },
          result: {
            countResultARR:this.countResultARR,
            DisplayResults:this.countText
          }
        }
        const res = await postFormula(data)
        if (res.code === 0) {
          Toast.success('提交成功')
          this.show=true
        } else {
          Toast.fail(res.message)
          this.show=true
        }
      },
      userChange (data) {
        if (data.birthday && data.birthday !== '') {
          this.nianling = this.calculateAge(data.birthday)
        } else {
          this.nianling = ''
        }
        this.xingbie = data.sex
        this.patientId = data.id
        this.selectValue = data
      },
    }
  }
  </script>
  
  
  <style scoped lang="scss">
    ::v-deep .custom-field .van-field__control::placeholder {
    font-size: 12px;
  }
  .index{
    background: #F6F6F6;
    padding: 10px 15px;
    height: 100%;
    .StandardDescription{
      margin-top:10px;
      .top_nav{
        font-size: 16px;
        color: #333333;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: start;
        margin-bottom:10px;
        span {
          display: inline-block;
          width: 5px;
          height: 15px;
          background: #259beb;
          margin-right: 5px;
        }
      }
      .StandardDeatil{
        width:100%;
        padding:15px 10px;
        //   height: 50px;
        background-color: #fff;
        box-sizing: border-box;
      }
    }
    .top_nav{
      font-size: 16px;
      color: #333333;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: start;
      margin-bottom:10px;
      span {
        display: inline-block;
        width: 5px;
        height: 15px;
        background: #259beb;
        margin-right: 5px;
      }
    }
    .formBody{
      background-color: #fff;
      padding-bottom:10px;
      .CalculationResultsBox{
        padding:0 8px;
        .CalculationResults{
          font-size: 16px;
          color: #333333;
          font-weight: bold;
          display: flex;
          justify-content: center;
          margin-bottom:10px
        }
        .CalculationDetail{
          font-size: 15px;
          color: #333333;
          // font-weight: bold;
          display: flex;
          align-items: center;
          justify-content: start;
          margin-bottom:10px;
          background-color: #f6f6f6;
          // height: 16px;
          span{
            display: inline-block;
            width: 3px;
            height: 24px;
            background: #fe9712;
            margin-right: 5px;
          }
        }
      }
    }
    .titles{
      display:flex;
      align-items: center;
      justify-content: space-between;
      width:100%;
      height: 50px;
      border-bottom: 1px solid #f0f0f0;
      padding: 0 10px;
      box-sizing: border-box;
      .titlesName{
        font-size:16px;
        i{
          color: red;
        }
      }
      .information{
        font-size:16px;
        margin-right:4px;
        .PleaseSelect{
          color: #b9b9b9;
        }
        .vanCell{
          width:50px;
          padding:0;
          height: 100%;
        }
      }
      .vBotton{
        width:60px
      }
      .unit{
        height: 50px;
        //   line-height: 50px;
        display: flex;
        align-items: center;
        font-size:16px;
        // width:40px;
      }
      .vanIcon{
        font-size:13px;
        color:#a8a8a8;
        font-weight: 650;
      }
    }
  }
  ::v-deep .van-cell {
    padding:0px 0px;
  }
  ::v-deep .van-field__control{
    height: 50px;
    font-size: 16px;
  }
  ::v-deep .van-field__error-message {
    position: absolute;
    top: 30px;
    left: 10px;
  }
  .StandardDeatil2{
    width:100%;
    padding: 15px 10px;
    padding-bottom:1px;
    //   height: 50px;
    background-color: #fff;
    box-sizing: border-box;
    .references{
      margin-bottom:15px
    }
  }
  ::v-deep p {
    padding: 0;
    margin: 0;
  }
  </style>
  